import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import map from 'lodash/map'
import TireLineTile from './TireLineTile'
import { Wrapper, Heading } from './common'

const FlexTireLines = ({ tireLines }) => map(tireLines, (tires, brand) =>
  <Wrapper key={ brand }>
    <Heading headline_narrow data-at-tireline-brand>{ brand }</Heading>
    <FlexContainer>
      {
        tires.map(tireProps =>
          <TireLineTile
            key={ tireProps.productId }
            { ...tireProps } />
        )
      }
    </FlexContainer>
  </Wrapper>
)

export default FlexTireLines

FlexTireLines.propTypes = {
  tireLines: PropTypes.shape()
}

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
